let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iDpf4")).then(() => parcelRequire('jw9xM'));